import { render, staticRenderFns } from "./BUploadImageV3.vue?vue&type=template&id=755056f0&scoped=true&"
import script from "./BUploadImageV3.vue?vue&type=script&lang=js&"
export * from "./BUploadImageV3.vue?vue&type=script&lang=js&"
import style0 from "./BUploadImageV3.vue?vue&type=style&index=0&id=755056f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755056f0",
  null
  
)

export default component.exports